export default __webpack_public_path__ + "static/media/dashboard_logo.3e2c2409.png";